(() => {
  const STORAGE_KEY = 'jacamarWishlist';
  const CHANGE_EVENT = 'jacamar:wishlist-changed';

  const normalize = (value) => [...new Set((Array.isArray(value) ? value : []).filter((item) => typeof item === 'string' && item.trim()).map((item) => item.trim()))];
  const getWishlistItems = () => {
    try { return normalize(JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]')); }
    catch { return []; }
  };
  const save = (handles) => {
    const normalized = normalize(handles);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { handles: normalized } }));
    return normalized;
  };
  const addWishlistItem = (handle) => save([...getWishlistItems(), handle]);
  const removeWishlistItem = (handle) => save(getWishlistItems().filter((item) => item !== handle));
  const isWishlistItemSaved = (handle) => getWishlistItems().includes(handle);
  const clearWishlist = () => save([]);
  const toggleWishlistItem = (handle) => isWishlistItemSaved(handle) ? removeWishlistItem(handle) : addWishlistItem(handle);

  window.JacamarWishlist = { getWishlistItems, addWishlistItem, removeWishlistItem, isWishlistItemSaved, clearWishlist, toggleWishlistItem, storageKey: STORAGE_KEY };

  const setButtonState = (button, saved) => {
    const title = button.dataset.productTitle || 'product';
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', `${saved ? 'Remove' : 'Add'} ${title} ${saved ? 'from' : 'to'} wishlist`);
    const icon = button.querySelector('[aria-hidden="true"]');
    if (icon) icon.textContent = saved ? '♥' : '♡';
    const label = button.querySelector('[data-wishlist-button-label]');
    if (label) label.textContent = saved ? 'Saved to Wishlist' : 'Add to Wishlist';
  };

  const syncUI = () => {
    const handles = getWishlistItems();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => setButtonState(button, handles.includes(button.dataset.wishlistToggle)));
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => { count.textContent = handles.length; count.hidden = handles.length === 0; });
    document.querySelectorAll('[data-wishlist-link]').forEach((link) => link.setAttribute('aria-label', `Wishlist, ${handles.length} saved item${handles.length === 1 ? '' : 's'}`));
  };

  const showToast = (message) => {
    const toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);
    window.setTimeout(() => toast.remove(), 2200);
  };

  const formatMoney = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, format);
    return (format || '${{amount}}').replace(/{{\s*amount[^}]*}}/, amount);
  };

  const addVariant = async (variantId) => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
    if (!response.ok) throw new Error('This light could not be added right now.');
    const cart = await fetch(root + 'cart.js').then((item) => item.json());
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; count.hidden = cart.item_count < 1; });
    document.querySelectorAll('[data-cart-link] em').forEach((label) => { label.textContent = `Cart (${cart.item_count})`; });
    document.dispatchEvent(new CustomEvent('jacamar:cart-updated', { detail: { cart } }));
    showToast('✓ Added to your cart');
  };

  const createUnavailable = (handle) => {
    const item = document.createElement('div');
    item.className = 'wishlist-unavailable';
    const copy = document.createElement('p');
    copy.textContent = 'This saved light is no longer available.';
    const remove = document.createElement('button');
    remove.type = 'button'; remove.textContent = 'Remove'; remove.dataset.wishlistRemove = handle;
    item.append(copy, remove);
    return item;
  };

  const createProductCard = (product, moneyFormat) => {
    const handle = product.handle;
    const productUrl = product.url || `/products/${handle}`;
    const availableVariant = product.variants?.find((variant) => variant.available);
    const media = document.createElement('div'); media.className = 'product-card__media';
    const imageLink = document.createElement('a'); imageLink.href = productUrl; imageLink.setAttribute('aria-label', product.title);
    const image = document.createElement('img'); image.className = 'product-card__image'; image.loading = 'lazy'; image.src = product.featured_image || product.images?.[0] || ''; image.alt = product.title;
    imageLink.append(image); media.append(imageLink);
    const remove = document.createElement('button'); remove.className = 'wishlist-card__remove'; remove.type = 'button'; remove.dataset.wishlistRemove = handle; remove.setAttribute('aria-label', `Remove ${product.title} from wishlist`); remove.textContent = '♥'; media.append(remove);
    const info = document.createElement('div'); info.className = 'product-card__info';
    const details = document.createElement('div');
    const title = document.createElement('h3'); const titleLink = document.createElement('a'); titleLink.href = productUrl; titleLink.textContent = product.title; title.append(titleLink);
    const price = document.createElement('div'); price.className = 'price'; price.textContent = product.price_varies ? `From ${formatMoney(product.price, moneyFormat)}` : formatMoney(product.price, moneyFormat);
    details.append(title, price); info.append(details);
    const actions = document.createElement('div'); actions.className = 'wishlist-card__actions';
    if (availableVariant && product.variants.length === 1) {
      const add = document.createElement('button'); add.type = 'button'; add.textContent = 'Add to cart'; add.addEventListener('click', () => addVariant(availableVariant.id).catch((error) => showToast(error.message))); actions.append(add);
    } else {
      const choose = document.createElement('a'); choose.href = productUrl; choose.textContent = availableVariant ? 'Choose options' : 'Unavailable'; actions.append(choose);
    }
    const view = document.createElement('a'); view.href = productUrl; view.textContent = 'View'; actions.append(view);
    const card = document.createElement('article'); card.className = 'product-card'; card.dataset.wishlistProduct = handle; card.append(media, info, actions);
    return card;
  };

  let renderToken = 0;
  const renderWishlistPage = async () => {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    const token = ++renderToken;
    const handles = getWishlistItems();
    const grid = page.querySelector('[data-wishlist-grid]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const loading = page.querySelector('[data-wishlist-loading]');
    const clear = page.querySelector('[data-wishlist-clear]');
    const count = page.querySelector('[data-wishlist-page-count]');
    grid.replaceChildren();
    empty.hidden = handles.length !== 0;
    loading.hidden = handles.length === 0;
    if (clear) clear.hidden = handles.length === 0;
    if (count) { count.hidden = handles.length === 0; count.textContent = `${handles.length} saved light${handles.length === 1 ? '' : 's'}`; }
    if (!handles.length) return;
    const root = window.Shopify?.routes?.root || '/';
    const results = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error();
        return createProductCard(await response.json(), page.dataset.moneyFormat);
      } catch { return createUnavailable(handle); }
    }));
    if (token !== renderToken) return;
    grid.replaceChildren(...results);
    loading.hidden = true;
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault(); event.stopPropagation();
      const saved = !isWishlistItemSaved(toggle.dataset.wishlistToggle);
      toggleWishlistItem(toggle.dataset.wishlistToggle);
      showToast(saved ? '♥ Saved to your wishlist' : 'Removed from your wishlist');
      return;
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) { removeWishlistItem(remove.dataset.wishlistRemove); showToast('Removed from your wishlist'); }
    if (event.target.closest('[data-wishlist-clear]')) clearWishlist();
  });

  window.addEventListener(CHANGE_EVENT, () => { syncUI(); renderWishlistPage(); });
  window.addEventListener('storage', (event) => { if (event.key === STORAGE_KEY) { syncUI(); renderWishlistPage(); } });
  document.addEventListener('shopify:section:load', () => { syncUI(); renderWishlistPage(); });
  document.addEventListener('jacamar:wishlist-refresh', syncUI);
  syncUI();
  renderWishlistPage();
})();
